import client from "./client";
export const getCourses = () => client.get("/courses");
export const getCourse = (id) => client.get(`/courses/${id}`);
export const createCourse = (formData) => client.post("/courses/create", formData);
export const updateCourse = (id, formData) => client.put(`/courses/update/${id}`, formData);
export const deleteCourse = (id) => client.delete(`/courses/delete/${id}`);
export const enrollCourse = (id) => client.post(`/courses/${id}/enroll`);
export const updateProgress = (id, progress) => client.put(`/courses/${id}/progress`, { progress });
export const unenrollCourse = (id) => client.delete(`/courses/${id}/unenroll`);
